import { Box, Popover, Typography } from "@mui/material";
import PermissionInfo from "components/permissionInfo";
import useLocales from "hooks/useLocales";

interface Props {
  anchorEl: HTMLElement | null;
  handlePopoverClose: () => void;
  title: string;
  locked?: boolean;
}

const NavItemPopover = ({
  anchorEl,
  handlePopoverClose,
  title,
  locked,
}: Props) => {
  const { translate } = useLocales();

  return (
    <Popover
      id="mouse-over-popover"
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: 50,
      }}
      sx={{
        pointerEvents: "none",
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus
      PaperProps={{
        sx: {
          bgcolor: "background.paper",
          borderRadius: "4px",
          p: 1,
          px: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            color: "text.greyLight",
            fontSize: "12px",
          }}
          variant="subtitle2"
        >
          {translate(title)}
        </Typography>
        {locked && <PermissionInfo />}
      </Box>
    </Popover>
  );
};
export default NavItemPopover;
